/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
global.FlexSearch = require('flexsearch')

export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (typeof window.IntersectionObserver === `undefined`) {
    import(`intersection-observer`)
    console.log(`# IntersectionObserver is polyfilled!`)
  }

  // load json data into window variable
  fetch(`${__PATH_PREFIX__}/flexsearch_index.json`)
    .then(function(response) {
      return response.json()
    })
    .then(function(index) {
        Object.keys(index).forEach(lng => {
          Object.keys(index[lng].index).forEach(idx => {
            const index_ = index[lng].index[idx]

            // load language files if needed by stemmer or filter
            if (
              index_.attrs.stemmer !== undefined ||
              index_.attrs.filter !== undefined
            ) {
              try {
                require('./src/creators/flexsearch-en')
              } catch (e) {
                console.error(e)
              }
            }
            // rebuild the index
            const indexObj = new FlexSearch(index_.attrs)
            indexObj.import(index_.values)
            index_.values = indexObj
          })
        })
        // load index into window variable
        window.__FLEXSEARCH__ = index
      }
    )
    .catch(function(e) {
      console.error('Failed fetch search index')
    })
}

export const onRouteUpdate = () => {
  if (window) {
    const mainTag = document.getElementsByTagName('main')[0]
    if (mainTag) {
      mainTag.scrollTo(0, 0)
    }
  }
}
